export const GF_FORM_SECTIONS = [
  {
    id: "consent",
    title: "Consent & Authorization",
    color: "#f59e0b",
    columnIds: ["1128", "1132", "1139"],
  },
  {
    id: "case_info",
    title: "Case Information",
    color: "#f59e0b",
    columnIds: ["1140", "1141", "1142", "1143", "1144", "1145", "1146", "1147"],
  },
  {
    id: "beneficiary",
    title: "Beneficiary Details",
    color: "#f59e0b",
    columnIds: [
      "1148", "1149", "1150", "1151", "1152",
      "1153", "1154", "1155", "1156", "1285",
      "1157", "1158", "1159", "1160", "1161",
    ],
  },
  {
    id: "family",
    title: "Family Details",
    color: "#f59e0b",
    columnIds: [
      "1162", "1163", "1164",
      "1165", "1166", "1167", "1168",
      "1286", "1289", "1290",
      "1169", "1170", "1171", "1172",
      "1287", "1291", "1292",
      "1173", "1295",
      "1174", "1175", "1176",
      "1288", "1293", "1294",
      "1177",
    ],
  },
  {
    id: "address",
    title: "Address Details",
    color: "#f59e0b",
    columnIds: [
      "1178", "1179", "1180", "1181", "1182",
      "1183", "1184", "1185", "1186",
      "1206", "1207", "1208", "1209", "1210",
    ],
  },
  {
    id: "medical",
    title: "Medical Details of Beneficiary",
    color: "#f59e0b",
    columnIds: [
      "1211", "1296", "1212", "1213",
      "1229", "1230", "1231",
      "1232", "1233", "1234", "1235", "1236", "1237", "1238",
      "1239", "1240",
    ],
  },
  {
    id: "financial",
    title: "Financial Assistance Details",
    color: "#f59e0b",
    columnIds: [
      "1241", "1242", "1243", "1244",
      "1245", "1246", "1247", "1248",
      "1249", "1250",
    ],
  },
  {
    id: "hospital",
    title: "Hospital Details",
    color: "#f59e0b",
    columnIds: ["1251", "1252"],
  },
  {
    id: "declaration",
    title: "Declaration",
    color: "#f59e0b",
    columnIds: [
      "1253", "1254", "1255", "1263", "1257",
      "1258", "1259",
      "1260", "1297", "1298", "1299",
      "1261", "1300",
    ],
  },

  {
    id: "verification",
    title: "Verification Form",
    color: "#0d9488",
    banner: {
      title: "Aadhaar/Voter ID, Address & Income Proof Verification for Genesis Foundation Financial Support for children with Congenital Heart Defects",
      description: "To verify the identity and address details of the beneficiary and their parent(s)/guardian(s) based on the submitted Aadhaar Card or Voter ID, please tick the appropriate option(s) indicating what has been verified.",
    },
    introColumnIds: ["1264"],
    subSections: [
      {
        id: "verification_beneficiary",
        title: "Aadhaar/Voter ID Verification Details of Beneficiary",
        columnIds: ["1265", "1267", "1266"],
      },
      {
        id: "verification_parents",
        title: "Aadhaar/Voter ID Verification Details of Parents/Legal Guardian",
        columnIds: ["1269", "1270", "1272", "1273", "1301"],
      },
      {
        id: "verification_income",
        title: "Income Proof Verification Details",
        columnIds: ["1275", "1276", "1277", "1278"],
      },
      {
        id: "verification_hospital",
        title: "Hospital Representative & Declaration",
        columnIds: ["1279", "1280", "1281"],
      },
    ],
    columnIds: [
      "1264",
      "1265", "1267", "1266",
      "1269", "1270", "1272", "1273", "1301",
      "1275", "1276", "1277", "1278",
      "1279", "1280", "1281",
    ],
  },
];

export const GF_ALL_COLUMN_IDS = GF_FORM_SECTIONS.flatMap((s) => s.columnIds);

export const GF_FORMULA_COLUMN_IDS = new Set(["1152", "1250"]);

export const GF_FULL_WIDTH_COLUMN_IDS = new Set([
  "1132",
  "1179",
  "1184",
  "1240",
  "1296",
  "1244",
  "1247",
  "1248",
  "1249",
  "1253", "1254", "1255", "1263",
  "1260", "1297", "1298", "1299",
  "1261", "1300",
  "1264",
  "1281",
]);
